export const BARGE_KIND_OPTIONS = [
  { label: 'VLSFO', value: 'VLSFO' },
  { label: 'HSFO', value: 'HSFO' },
  { label: 'ULSFO', value: 'ULSFO' },
  { label: 'HSDO', value: 'HSDO' },
  { label: 'LSDO', value: 'LSDO' },
]

export const FUEL_GRADES_BY_KIND = {
  HSDO: ['DMA (max 1.5% S)', 'DMA MAX 0.5 %S', 'DMB MAX 0.5 %S', 'OTHER'],
  HSFO: [
    'RME 180 (max 3.5% S)',
    'RMG 180 (max 3.5% S)',
    'RMG 380 (max 3.5% S)',
    'RMK 500 (max 3.5% S)',
    'RMK 700 (max 3.5% S)',
    'OTHER',
  ],
  LSDO: ['DMA (max 0.1% S)', 'DMB (max 0.1% S)', 'DMC (max 0.1% S)', 'OTHER'],
  ULSFO: [
    'RMD 80 (max 0.1% S)',
    'RME 180 (max 0.1% S)',
    'RMG 380 (max 0.1% S)',
    'OTHER',
  ],
  VLSFO: [
    'RMB 30 0,50%S',
    'RMD 80 (max 0.5% S)',
    'RME 180 (max 0.5% S)',
    'RMG 180 (max 0.5% S)',
    'RMG 380 (max 0.5% S)',
    'RMG 380 (max 0.5% S) BIO10',
    'RMG 380 (max 0.5% S) BIO20',
    'RMG 380 max. 0.50%S BIO24',
    'RMG 380 max. 0.50%S BIO30',
    'RMK 500 (max 0.5% S)',
    'RMK 500 (max 0.5% S) BIO20',
    'RMK 500 (max 0.5% S) BIO30',
    'RMK 500 (max 0.5% S) BIO45',
    'RMK 700 MAX 0,50 %S',
    'OTHER',
  ],
}

export const getFuelGradeOptions = kind => {
  const values = FUEL_GRADES_BY_KIND[kind] || []

  return values.map(value => ({ label: value, value }))
}
